import React from 'react';
import {EOYWizard} from './EOYWizard';
import {getServerTexts} from './texts';

export async function renderEOYWizard(root) {
    await getServerTexts();
    const eoyWizardRef: React.RefObject<typeof EOYWizard> = React.createRef();
    root.render(<EOYWizard ref={eoyWizardRef} />);
    return eoyWizardRef;
}
